<form [formGroup]="levelForm" (ngSubmit)="onSubmit()" class="grid gap-4 pt-2">
  <mat-form-field class="w-full">
    <mat-label>Level</mat-label>
    <input matInput formControlName="level" type="number" />
    @if (levelForm.get('level')?.hasError('required')) {
      <mat-error>Level is required</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="w-full">
    <mat-label>Name</mat-label>
    <input matInput formControlName="name" type="text" />
    @if (levelForm.get('name')?.hasError('required')) {
      <mat-error>Name is required</mat-error>
    }
  </mat-form-field>

  <button mat-raised-button color="primary" [disabled]="levelForm.invalid || saving()">
    Save
  </button>
</form>